import React, { useState, useEffect, useRef } from "react";

import { useTranslation } from "react-i18next";

import useAuth from "../../../../hooks/useAuth";

import { Grid, CircularProgress, Autocomplete } from "@mui/material";

import IALoadingButton from "../../../../components/IAButtons/IALoadingButton";
import ContainerCard from "../../../../components/Cards/ContainerCard";
import TaskTabsModal from "../../../../components/Modal/TaskTabsModal";
import RoundedDatePicker from "../../../../components/DateField/RoundedDatePicker";
import AutoComplete from "../../../../components/AutoComplete";

import { GET_TIME_BY_EMPLOYEE } from "../../../../graphql/reports";
import { GET_ALL_PROJECTS_DROPDOWN } from "../../../../graphql/project";
import { GET_ALL_EMPLOYEES_DROPDOWN } from "../../../../graphql/employee";
import { GET_ALL_RESOURCES } from "../../../../graphql/resource";

import useQueryAuth from "../../../../hooks/useQueryAuth";
import useLazyQueryAuth from "../../../../hooks/useLazyQueryAuth";

import urls from "../../../../urls";

import { useSnackbar } from "notistack";

import { TimeByEmployeeTable } from "./_table";

import colors from "../../../../assets/theme/light/colors";

import { handleValidateDates } from "../../../../utils/functions";
import RoundedTextField from "../../../../components/TextFields/RoundedTextField";
import AutoCompletePaper from "../../../../components/Paper/AutoCompletePaper";
import Tooltip from "../../../../components/Tooltip";
import { NextIcon, PreviousIcon } from "../../../../components/Icon";
import {
	DATE_FILTER_DATA,
	handleDateBackward,
	handleDateForward,
	handleTimeBetween,
} from "../../../../utils/period";

import { v4 as uuidv4 } from "uuid";
import {
	GET_ALL_CUSTOMERS_DROPDOWN,
	GET_ALL_PROJECT_DIMENSIONS,
} from "../../../../graphql/customer";

function TimeByEmployee() {
	const {
		storeUserTenant,
		storeUserGuid,
		userRoles,
		projectDimension1Label,
		projectDimension2Label,
	} = useAuth();

	const { dark_logo_blue } = colors;

	const { t } = useTranslation();

	const data_filter = DATE_FILTER_DATA(t);

	const { enqueueSnackbar } = useSnackbar();

	const { my_projects_form, my_project_direct_tasks_form } = urls;

	const { manageTimeEntry } = userRoles;

	const [re, setRe] = useState(false);

	const nowDate = new Date();

	const firstDayOfWeek = new Date(nowDate);
	firstDayOfWeek.setDate(
		nowDate.getDate() - nowDate.getDay() + (nowDate.getDay() === 0 ? -6 : 1)
	);

	const [dateFrom, setDateFrom] = useState(firstDayOfWeek);

	const lastDayOfWeek = new Date(firstDayOfWeek);
	lastDayOfWeek.setDate(firstDayOfWeek.getDate() + 6);

	const [dateTo, setDateTo] = useState(lastDayOfWeek);

	const [dateVal, setDateVal] = useState(
		data_filter.find((x) => x.mnemonic === "week")
	);

	const [open, setOpen] = useState(false);

	const [projectIDs, setProjectIDs] = useState([]);
	const [employeeIDs, setEmployeeIDs] = useState([]);

	const [resourceValue, setResourceValue] = useState(null);
	const [fetchCustomers, setFetchCustomers] = useState(false);
	const [customerID, setCustomerID] = useState(null);

	const [employeeValue, setEmployeeValue] = useState([]);
	const [projectsValue, setProjectsValue] = useState([]);

	const [taskID, setTaskID] = useState(null);
	const [taskName, setTaskName] = useState(null);
	const [projectID, setProjectID] = useState(null);
	const [projectName, setProjectName] = useState(null);
	const [openModal, setOpenModal] = useState(false);
	const [timer, setTimer] = useState(null);
	const [list, setList] = useState(null);

	const [fetchEmployees, setFetchEmployees] = useState();
	const [fetchProjects, setFetchProjects] = useState();
	const type = useRef("task");

	const [fetchDimensions, setFetchDimensions] = useState(false);

	const [selectedDimensions, setSelectedDimensions] = useState({
		projectDimension1: null,
		projectDimension2: null,
	});

	const {
		data: projectDimensions,
		loading: projectDimensionsLoading,
		tokenChange: projectDimensionsWait,
	} = useQueryAuth(GET_ALL_PROJECT_DIMENSIONS, "GetAllProjectDimensions", {
		variables: {
			model: {
				userID: storeUserGuid,
			},
		},
		skip: !fetchDimensions,
		isWait: fetchDimensions,
	});

	// const includeOptions = [
	//   {
	//     id:1,
	//     title:t("reports.BillableAndNonBillable.label")
	//   },
	//   {
	//     id:2,
	//     title:t("reports.onlyBillable.label")
	//   },
	//   {
	//     id:3,
	//     title:t("reports.onlyNonBillable.label")
	//   },
	// ];

	// const [includeOption, setIncludeOption] = useState({
	//   id:1,
	//   title:t("reports.BillableAndNonBillable.label")
	// });

	const {
		data: employeeData,
		loading: employeeLoading,
		tokenChange: employeeWait,
	} = useQueryAuth(GET_ALL_EMPLOYEES_DROPDOWN, "GetCompanyUsersList", {
		variables: {
			model: {
				enableFilters: false,
				tenantID: storeUserTenant,
				userID: storeUserGuid,
				timeEntryDisabled: true,
				showAll: true,
				activeUsers: true,
			},
		},
		skip: !fetchEmployees,
		isWait: fetchEmployees,
	});
	const {
		data: customersData,
		loading: customerLoading,
		tokenChange: customerWait,
	} = useQueryAuth(GET_ALL_CUSTOMERS_DROPDOWN, "GetAllCustomers", {
		variables: {
			model: {
				enableFilters: false,
				userID: storeUserGuid,
			},
		},
		skip: !fetchCustomers,
		isWait: fetchCustomers,
	});

	const employeeList =
		employeeData?.GetCompanyUsersList?.usersList?.employees || [];
	const customerList = customersData?.GetAllCustomers?.customers || [];

	const {
		data: projectsData,
		loading: projectLoading,
		tokenChange: projectsWait,
	} = useQueryAuth(GET_ALL_PROJECTS_DROPDOWN, "GetAllProjects", {
		variables: {
			model: {
				enableFilters: false,
				tenantID: storeUserTenant,
				userID: storeUserGuid,
			},
		},
		skip: !fetchProjects,
		isWait: fetchProjects,
	});

	const projectsList =
		projectsData?.GetAllProjects?.projectsList?.projectViews || [];

	const {
		mfunction: getData,
		refetch,
		loading: dataLoading,
	} = useLazyQueryAuth(GET_TIME_BY_EMPLOYEE, "GetTimeByEmployee");

	// const list = projectData?.GetTimeByEmployee?.timeByEmployee?.employees || [];
	function disableDates(date) {
		const oneDayBefore = new Date(dateFrom);
		oneDayBefore.setDate(oneDayBefore?.getDate() - 1);
		return date < oneDayBefore;
	}

	useEffect(() => {
		const oneDayBefore = new Date(dateFrom);
		oneDayBefore.setDate(oneDayBefore?.getDate() - 1);
		// let onlyBillable = includeOption?.id == 2;
		// let onlyNotBillable = includeOption?.id == 3;
		if (!employeeWait && !projectsWait && oneDayBefore <= dateTo) {
			getData(
				{
					variables: {
						model: {
							userID: storeUserGuid,
							projectGuids: projectIDs.length > 0 ? projectIDs : null,
							employeeGuids: employeeIDs.length > 0 ? employeeIDs : null,
							dateFrom: new Date(dateFrom).toDateString(),
							dateTo: new Date(dateTo).toDateString(),
							customerGuid: customerID?.customerGuid || null,
							projectDimension1: selectedDimensions.projectDimension1
								? selectedDimensions.projectDimension1.value
								: undefined,
							projectDimension2: selectedDimensions.projectDimension2
								? selectedDimensions.projectDimension2.value
								: undefined,
							// onlyBillable: onlyBillable,
							// onlyNotBillable: onlyNotBillable
						},
					},
				},
				(response) => {
					if (response["GetTimeByEmployee"].timeByEmployee != null)
						setList(
							response?.GetTimeByEmployee?.timeByEmployee?.employees
						);
					else
						enqueueSnackbar(
							t(response["GetTimeByEmployee"].errorMessage),
							{
								variant: "error",
								autoHideDuration: 5000,
							}
						);
				}
			);
		}
	}, [projectsWait, employeeWait, re, resourceValue]);

	const handleOpenModal = (event, row, parentName, parent) => {
		event.preventDefault();
		setTaskID(row?.id);
		setProjectID(parent);
		setTaskName(row?.name);
		setProjectName(parentName);
		setOpenModal(true);
	};

	// const handleValidateDates = (value) => {
	//   if (timer) {
	//     //if timer is set, we empty it so it's not called and wait another delay
	//     clearTimeout(timer);
	//     setTimer(null);
	//   }

	//   //set timer for after 2 seconds of wait
	//   setTimer(
	//     setTimeout(() => {
	//       const oneDayBefore = new Date(dateFrom);
	//       oneDayBefore.setDate(oneDayBefore?.getDate() - 1);
	//       if (value < oneDayBefore)
	//         enqueueSnackbar(t("employeeTimesheet.invalid.date"), {
	//           variant: "error",
	//           autoHideDuration: 5000
	//         });
	//       else setDateTo(value);
	//     }, 500)
	//   );
	// };

	return (
		<>
			<TaskTabsModal
				showModal={openModal}
				setShowModal={(v) => setOpenModal(v)}
				loading={dataLoading}
				projectID={projectID}
				projectName={projectName}
				taskID={taskID}
				handleChangeProject={(v) => setProjectID(v)}
				handleChangeTask={(v) => setTaskID(v)}
				taskName={taskName}
				refetch={refetch}
				fromProject={true}
				setType={(v) => (type.current = v)}
				type={type.current}
				open={JSON.parse(sessionStorage.getItem("unsavedChanges"))}
				modifyFormFlag={() =>
					sessionStorage.setItem("unsavedChanges", JSON.stringify(false))
				}
			/>
			<Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
				<ContainerCard
					className="projects-card"
					sx={{
						width: "100%",
						padding: "10px",
						display: "grid",
						gridTemplateColumn: "1fr",
						backgroundColor: "transparent !important",
						boxShadow: "none !important",
						gap: "20px",
					}}
				>
					<Grid container spacing={1}>
						{manageTimeEntry !== "N" && (
							<Grid
								item
								xs={12}
								sm={5}
								md={4}
								lg={3}
								xl={3}
								sx={{ marginBottom: "10px !important" }}
							>
								<AutoComplete
									multiple
									disableCloseOnSelect
									loading={employeeLoading}
									options={employeeList}
									getOptionLabel={(option) =>
										option
											? option.firstName + " " + option.lastName
											: ""
									}
									renderOption={(props, option) => (
										<li {...props} key={uuidv4()}>
											{option.firstName + " " + option.lastName}
										</li>
									)}
									identifier={"employeeGuid"}
									size="small"
									value={employeeValue}
									onOpen={() => setFetchEmployees(true)}
									onClose={() => setFetchEmployees(false)}
									onChange={(event, value) => {
										setEmployeeValue(value);
										let tmp = [];
										value.map((ids, inxex) => {
											tmp.push(ids.employeeGuid);
										});
										setEmployeeIDs(tmp);
									}}
									sx={{
										"& .MuiInputBase-input": {
											fontSize: "13px !important",
										},
										"& .MuiChip-root": {
											marginLeft: "15px !important",
										},
									}}
									roundedTextField
									label={t("reports.label.employee")}
								/>
							</Grid>
						)}
						<Grid
							item
							xs={12}
							sm={6}
							md={3}
							lg={3}
							xl={3}
							sx={{ marginBottom: "10px !important" }}
						>
							<AutoComplete
								multiple
								disableCloseOnSelect
								loading={projectLoading}
								options={projectsList}
								getOptionLabel={(option) =>
									option ? option.title : ""
								}
								renderOption={(props, option) => (
									<li {...props} key={uuidv4()}>
										{option.title}
									</li>
								)}
								identifier={"projectGuid"}
								size="small"
								value={projectsValue}
								onOpen={() => setFetchProjects(true)}
								onClose={() => setFetchProjects(false)}
								onChange={(event, value) => {
									setProjectsValue(value);
									let tmp = [];
									value.map((ids, inxex) => {
										tmp.push(ids.projectGuid);
									});
									setProjectIDs(tmp);
								}}
								sx={{
									"& .MuiInputBase-input": {
										fontSize: "13px !important",
									},
									"& .MuiChip-root": {
										marginLeft: "15px !important",
									},
								}}
								roundedTextField
								label={t("reports.label.projects")}
							/>
						</Grid>

						<Grid
							item
							xs={12}
							sm={6}
							md={3}
							lg={3}
							xl={3}
							sx={{ marginBottom: "10px !important" }}
						>
							<AutoComplete
								multiple={false}
								loading={customerLoading}
								options={customerList}
								getOptionLabel={(option) => (option ? option.name : "")}
								renderOption={(props, option) => (
									<li {...props} key={uuidv4()}>
										{option.name}
									</li>
								)}
								identifier={"customerGuid"}
								size="small"
								value={customerID}
								onOpen={() => setFetchCustomers(true)}
								onClose={() => setFetchCustomers(false)}
								onChange={(event, value) => {
									setCustomerID(value);
								}}
								sx={{
									"& .MuiInputBase-input": {
										fontSize: "13px !important",
									},
								}}
								label={t("reports.label.customer")}
								roundedTextField
							/>
						</Grid>
						<Grid
							item
							xs={12}
							sm={6}
							md={3}
							lg={3}
							xl={3}
							sx={{ marginBottom: "10px !important" }}
						>
							<AutoComplete
								multiple={false}
								loading={projectDimensionsLoading}
								options={
									projectDimensions?.GetAllProjectDimensions?.projectDimension1?.map(
										(dimension) => ({
											name: dimension,
											value: dimension,
										})
									) || []
								}
								getOptionLabel={(option) => (option ? option.name : "")}
								renderOption={(props, option) => (
									<li {...props} key={uuidv4()}>
										{option.name}
									</li>
								)}
								identifier={"projectDimension1"}
								size="small"
								value={selectedDimensions.projectDimension1}
								onOpen={() => setFetchDimensions(true)}
								onClose={() => setFetchDimensions(false)}
								onChange={(event, value) => {
									setSelectedDimensions((prev) => ({
										...prev,
										projectDimension1: value,
									}));
								}}
								sx={{
									"& .MuiInputBase-input": {
										fontSize: "13px !important",
									},
								}}
								label={projectDimension1Label}
								roundedTextField
							/>
						</Grid>
						<Grid
							item
							xs={12}
							sm={6}
							md={3}
							lg={3}
							xl={3}
							sx={{ marginBottom: "10px !important" }}
						>
							<AutoComplete
								multiple={false}
								loading={projectDimensionsLoading}
								options={
									projectDimensions?.GetAllProjectDimensions?.projectDimension2?.map(
										(dimension) => ({
											name: dimension,
											value: dimension,
										})
									) || []
								}
								getOptionLabel={(option) => (option ? option.name : "")}
								renderOption={(props, option) => (
									<li {...props} key={uuidv4()}>
										{option.name}
									</li>
								)}
								identifier={"projectDimension2"}
								size="small"
								value={selectedDimensions.projectDimension2}
								onOpen={() => setFetchDimensions(true)}
								onClose={() => setFetchDimensions(false)}
								onChange={(event, value) => {
									setSelectedDimensions((prev) => ({
										...prev,
										projectDimension2: value,
									}));
								}}
								sx={{
									"& .MuiInputBase-input": {
										fontSize: "13px !important",
									},
								}}
								label={projectDimension2Label}
								roundedTextField
							/>
						</Grid>

						{/* <Grid item xs={12} sm={6} md={3} lg={3} xl={3}> */}
						{/*   <AutoComplete
                options={includeOptions}
                getOptionLabel={(option) => (option ? option.title : "")}
                renderOption={(props, option) => (
                  <li {...props} key={uuidv4()}>
                    {option.title}
                  </li>
                )}
                identifier={"id"}
                size="small"
                value={includeOption}
                required
                onChange={(event, value) => {
                  setIncludeOption(value);
                  
                }}
                sx={{
                  "& .MuiInputBase-input": { fontSize: "13px !important" },
                  "& .MuiChip-root": {
                    marginLeft: "15px !important",
                  },
                }}
                roundedTextField
                label={t("reports.label.includeOption")}
              /> */}
						{/* </Grid> */}
						{/* <Grid item xs={12} sm={1} md={1} lg={3} xl={3}></Grid> */}
						<Grid item xs={12} sm={4} md={3} lg={2} xl={2}>
							<RoundedDatePicker
								className="date_picker_styles"
								label={t("projectDashboard.label.DateFrom")}
								value={dateFrom}
								disableFuture
								onChange={(newValue) => {
									setDateFrom(newValue);
									setDateVal(
										data_filter.find((x) => x.mnemonic === "custom")
									);
								}}
								onClose={() => setOpen(true)}
							/>
						</Grid>
						<Grid item xs={12} sm={4} md={3} lg={2} xl={2}>
							<RoundedDatePicker
								className="date_picker_styles"
								label={t("projectDashboard.label.DateTo")}
								value={dateTo}
								shouldDisableDate={disableDates}
								autoFocus={open}
								open={open}
								onClose={() => setOpen(false)}
								onClick={() => setOpen(!open)}
								onOpen={() => setOpen(!open)}
								onChange={(newValue) => {
									handleValidateDates(
										timer,
										setTimer,
										dateFrom,
										newValue,
										setDateTo,
										enqueueSnackbar,
										t
									);
									setDateVal(
										data_filter.find((x) => x.mnemonic === "custom")
									);
								}}
							/>
						</Grid>
						<Tooltip title={t("tooltip.PreviousPeriod")}>
							<Grid item sx={{ display: "flex", alignItems: "center" }}>
								<PreviousIcon
									color={
										dateVal.mnemonic === "custom"
											? "#73717380"
											: "#737173"
									}
									onClick={() => {
										if (dateVal.mnemonic !== "custom")
											handleDateBackward(
												dateFrom,
												dateTo,
												dateVal,
												setDateFrom,
												setDateTo
											);
									}}
								/>
							</Grid>
						</Tooltip>
						<Grid item xs={12} sm={4} md={2} lg={1.5} xl={1.5}>
							<Autocomplete
								options={data_filter}
								getOptionLabel={(option) =>
									option ? t(option.name) : ""
								}
								renderOption={(props, option) => (
									<li {...props} key={uuidv4()}>
										{option.name}
									</li>
								)}
								isOptionEqualToValue={(option, value) =>
									value == "" || option.mnemonic === value.mnemonic
								}
								size="small"
								disableClearable
								value={dateVal}
								onChange={(event, value) => {
									setDateVal(value);
									handleTimeBetween(
										value.mnemonic,
										setDateFrom,
										setDateTo
									);
								}}
								fullWidth
								PaperComponent={(props) => (
									<AutoCompletePaper {...props} />
								)}
								renderInput={(params) => (
									<RoundedTextField
										label={t("dateFilter.label")}
										size="small"
										removeMinWidth
										{...params}
									/>
								)}
								sx={{
									".MuiInputBase-input": {
										fontSize: "14px !important",
									},
								}}
							/>
						</Grid>
						<Tooltip title={t("tooltip.NextPeriod")}>
							<Grid item sx={{ display: "flex", alignItems: "center" }}>
								<NextIcon
									color={
										dateVal.mnemonic === "custom"
											? "#73717380"
											: "#737173"
									}
									onClick={() => {
										if (dateVal.mnemonic !== "custom")
											handleDateForward(
												dateFrom,
												dateTo,
												dateVal,
												setDateFrom,
												setDateTo
											);
									}}
								/>
							</Grid>
						</Tooltip>
						<Grid
							item
							xs={12}
							sm={12}
							md={manageTimeEntry === "N" ? 6 : 2}
							lg={manageTimeEntry === "N" ? 5 : 2}
							xl={manageTimeEntry === "N" ? 5 : 2}
							sx={{ display: "flex", justifyContent: "end" }}
						>
							<IALoadingButton
								onClick={() => setRe((val) => !val)}
								style={{
									width: "150px",
									backgroundColor: dark_logo_blue,
									borderRadius: "50px",
									height: "36px",
								}}
								label={t("projectDashboard.Search")}
							/>
						</Grid>
					</Grid>

					<Grid
						item
						xs={12}
						sm={12}
						md={12}
						lg={12}
						xl={12}
						sx={{ overflowX: "auto" }}
					>
						{dataLoading && (
							<div
								style={{
									color: "grey",
									textAlign: "center",
									padding: "5px",
									fontFamily: "poppins  !important",
								}}
							>
								<CircularProgress />
							</div>
						)}
						{!dataLoading && list && (
							<TimeByEmployeeTable
								data={list}
								t={t}
								handleOpenModal={handleOpenModal}
								generateProjectRoute={(row) =>
									my_projects_form.replace(
										"/:pName/:pID",
										`/${encodeURIComponent(
											row?.projectTitle
										)}/${encodeURIComponent(row?.projectGuid)}`
									)
								}
								generateTaskRoute={(row, parentName, parent) =>
									my_project_direct_tasks_form
										.replace(
											"/:pName/:pID",
											`/${encodeURIComponent(parentName)}/${encodeURIComponent(
												parent
											)}`
										)
										.replace(
											"/:tskName/:tskID",
											`/${encodeURIComponent(row?.name)}/${encodeURIComponent(
												row?.id
											)}`
										)
								}
							/>
						)}
						{!dataLoading && (!list || list.length == 0) && (
							<div
								style={{
									color: "grey",
									textAlign: "center",
									padding: "5px",
									fontFamily: "poppins  !important",
								}}
							>
								{t("employeeTimesheet.no.timeLog")}
							</div>
						)}
					</Grid>
				</ContainerCard>
			</Grid>
		</>
	);
}

export default TimeByEmployee;
